import { TValidator } from "../../../../wizard/types";

const validator: TValidator = async ({ values }) => {
  const errors: { [key: string]: any } = {};

  if (!values.old_password) {
    errors.old_password = "Current password is required.";
  }

  if (!values.password) {
    errors.password = "New password is required.";
  } else if (values.password.length < 8) {
    errors.password = "New password must have minimum 8 characters.";
  } else if (values.password.length > 15) {
    errors.password = "New password maximum length should be 15 characters.";
  }

  if (!values.password_confirmation) {
    errors.password_confirmation = "Password confirmation is required.";
  }

  if (
    values.password &&
    values.password_confirmation &&
    values.password !== values.password_confirmation
  ) {
    errors.password = "Passwords do not match.";
    errors.password_confirmation = "Passwords do not match.";
  }

  if (Object.keys(errors).length > 0) {
    throw errors;
  }
};

export default validator;
